// SmartoERP report design system — one look for every report: header, stat cards, status badges.
const TONES = {
  blue: 'border-l-blue-500', amber: 'border-l-amber-500', violet: 'border-l-violet-500', rose: 'border-l-rose-500',
  emerald: 'border-l-emerald-500', slate: 'border-l-slate-400', teal: 'border-l-teal-500',
};
const STATUS = {
  verified: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  unverified: 'bg-amber-50 text-amber-800 border-amber-200',
  review: 'bg-rose-50 text-rose-700 border-rose-200',
  info: 'bg-slate-50 text-slate-600 border-slate-200',
};

export function StatusBadge({ kind = 'info', children, testId }) {
  return <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full border text-[10px] font-semibold whitespace-normal break-words text-left ${STATUS[kind]}`} data-testid={testId}>{children}</span>;
}

export function ReportHeader({ icon: Icon, title, subtitle, actions, testId = 'report-header' }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-testid={testId}>
      <div className="flex items-center gap-3 min-w-0">
        {Icon && <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0"><Icon size={20} /></div>}
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-bold font-display tracking-tight truncate">{title}</h1>
          {subtitle && <p className="text-xs text-muted-foreground truncate">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, tone = 'slate', status, delta, action, onClick, testId }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag type={onClick ? 'button' : undefined} onClick={onClick} data-testid={testId}
      className={`text-left w-full rounded-xl border border-border border-l-4 ${TONES[tone] || TONES.slate} bg-card p-3 sm:p-4 shadow-sm transition-colors ${onClick ? 'hover:bg-muted/40 cursor-pointer' : ''}`}>
      <div className="flex items-start justify-between gap-1">
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold truncate min-w-0">{label}</p>
        {action}
      </div>
      <p className="text-base sm:text-xl font-bold mt-1 tabular-nums break-words">{value}</p>
      {(sub || status || delta) && (
        <div className="flex flex-wrap items-center gap-1.5 mt-1 text-[11px] text-muted-foreground">
          {status}{sub && <span className="min-w-0">{sub}</span>}{delta}
        </div>
      )}
    </Tag>
  );
}
